import Image from 'next/legacy/image';

import { Air } from '@air/next-icons';
import { Portal } from '@air/primitive-portal';

import CatDoingThings from '~/assets/cat-doing-things.svg';
import { MAINTENANCE_MODE_CONTAINER } from '~/constants/testIDs';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';

type MaintenanceModeProps = {
  children: JSX.Element;
};

export const MaintenanceMode = ({ children }: MaintenanceModeProps) => {
  const { maintenanceModeJson } = useFeatureFlags();

  if (maintenanceModeJson?.maintenanceMessage) {
    return (
      <Portal>
        <div
          className="fixed top-0 left-0 z-10 flex size-full flex-col items-center gap-4 bg-gray-1 px-8 pt-16"
          data-testid={MAINTENANCE_MODE_CONTAINER}
        >
          <Air className="w-[65px] text-gray-12" />
          <Image alt="A cat doing things" src={CatDoingThings} height={220} width={370} />
          <h1 className="mb-2 text-center font-semibold text-32 text-gray-12 md:text-40">
            Air is currently unavailable
          </h1>
          <p className="max-w-screen-sm text-balance text-center text-20 text-gray-10">
            {maintenanceModeJson.maintenanceMessage}
          </p>
        </div>
      </Portal>
    );
  }

  return children;
};
